import React, { useState } from 'react';
import { Grid, Snackbar, Alert } from '@mui/material';
import UpdatePolicyForm from '../../../components/Forms/UpdatePolicyForm';

const UpdatePolicyPage = () => {
  const [open, setOpen] = useState(false);
  const [pTitle, setPTitle] = useState('Update the Policy');
  // const [type, setType] = useState('HR_HANDBOOK');

  const handleSuccess = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Grid container spacing={3}>
      <Grid item sx={{ width: '100%' }}>
        <UpdatePolicyForm onSuccess={handleSuccess} pTitle={pTitle} type='HR_HANDBOOK' />
      </Grid>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleClose}
          severity="success"
          sx={{ width: '100%' }}
          variant="filled"
        >
          Policy saved successfully!
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default UpdatePolicyPage;
